import React from 'react'
import { withRouter, Route, Switch } from 'react-router-dom'
import api from '../shared/api'
import Welcome from '../pages/Welcome'
import Board from '../pages/Board'
import Thanks from '../pages/Thanks'

import '../stylesheets/components/Layout.scss'

class Layout extends React.Component {
    state = {
        page: 0,
    }
    componentDidMount = () => {
        api.create(
            this.props.match.params.slug,
            window.localStorage.getItem(this.props.match.params.slug) || null,
        ).then((response) => {
            window.localStorage.setItem(this.props.match.params.slug, response.data.validator.uid)
            this.setState({ ...response.data })
        })
    }
    componentDidUpdate = () => {
        const uri = this.props.location.pathname
            .replace('/' + this.props.match.params.slug, '')
            .replace(/^\/|\/$/g, '')
        const pages = [``, ...this.state.rounds.map((round, key) => `board/${key + 1}`), `thanks`]
        if (this.state.page !== pages.indexOf(uri)) this.setState({ page: pages.indexOf(uri) })
    }
    render() {
        return (
            <>
                {this.state.validation && (
                    <div
                        className="Layout"
                        style={{ backgroundColor: this.state.validation.color }}>
                        <div
                            className="Layout_progress"
                            style={{
                                width:
                                    (100 / (this.state.rounds.length + 1)) * this.state.page + '%',
                            }}></div>
                        <div className="Layout_canvas">
                            <Switch>
                                <Route
                                    path="/:slug/board/:round"
                                    render={() => <Board {...this.state} />}
                                />
                                <Route
                                    path="/:slug/thanks"
                                    render={() => <Thanks {...this.state} />}
                                />
                                <Route path="/:slug" render={() => <Welcome {...this.state} />} />
                            </Switch>
                        </div>
                    </div>
                )}
            </>
        )
    }
}

export default withRouter(Layout)
